import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { "data-cy": "orderRow" };
const _hoisted_2 = { class: "text-start" };
const _hoisted_3 = { class: "text-start" };
const _hoisted_4 = { class: "text-start" };
const _hoisted_5 = { class: "text-start" };
const _hoisted_6 = { style: { "width": "30%" } };
import StatusDisplay from "@/components/admin/StatusDisplay.vue";
import { Formatter } from "@/util/Formatter";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderListRow',
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                _createElementVNode("td", _hoisted_2, _toDisplayString(_unref(Formatter).bookingNumber(__props.order)), 1),
                _createElementVNode("td", _hoisted_3, _toDisplayString(__props.order.customer.firstname) + " " + _toDisplayString(__props.order.customer.lastname), 1),
                _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(Formatter).date(__props.order.orderDatetime)), 1),
                _createElementVNode("td", _hoisted_5, [
                    _createVNode(StatusDisplay, {
                        "order-status": __props.order.orderStatus,
                        "payment-status": __props.order.paymentStatus
                    }, null, 8, ["order-status", "payment-status"])
                ]),
                _createElementVNode("td", _hoisted_6, _toDisplayString(__props.order.customerRemarks), 1)
            ]));
        };
    }
});
